import React, { type JSX } from 'react';
import EnhancedMarkdown from '../EnhancedMarkdown/EnhancedMarkdown';
import {
  IconDefaultsContextProvider,
  iconSizeExtraLarge,
} from '../../contexts/useIconDefaults';
import BuildsItemBreakdown from '@resources/js/components/BuildsItemBreakdown/BuildsItemBreakdown';
import { EnhancedMarkdownOptionsContextProvider } from '@resources/js/contexts/useEnhancedMarkdownOptions';
import BuildsNoDataPlaceholder from '../BuildsNoDataPlaceholder/BuildsNoDataPlaceholder';
import { type BuildsItemBreakdownViewModel } from '@resources/js/components/BuildsBestEnchantsSection/BuildsBestEnchantsSection';
import buildsEnhancedMarkdownOverrides from '@resources/js/helpers/buildsEnhancedMarkdownOverrides';

export type BuildsBestRunesViewModel = {
  title: string;
  description: string;
  itemLabel: string;
  popularityLabel: string;
  itemBreakdowns: BuildsItemBreakdownViewModel[];
};

const enhancedMarkdownOptions = {
  lazyLoad: false,
};

const iconDefaults = {
  icon: {
    size: iconSizeExtraLarge,
    rounded: false,
    bordered: true,
  },
  item: { size: 20 },
  ability: { size: 20 },
};

export default function BuildsBestRunesSection({
  title,
  description,
  itemLabel,
  popularityLabel,
  itemBreakdowns,
}: BuildsBestRunesViewModel): JSX.Element {
  return (
    <EnhancedMarkdownOptionsContextProvider value={enhancedMarkdownOptions}>
      <div className='builds-best-runes-section'>
        <EnhancedMarkdown
          markdown={`
# ${title}

${description}
`}
          overrides={buildsEnhancedMarkdownOverrides}
        />
        {itemBreakdowns.length > 0 ? (
          <IconDefaultsContextProvider overrides={iconDefaults}>
            <div className='builds-best-runes-section__header'>
              <div className='builds-best-runes-section__header-section builds-best-runes-section__header-section--left'>
                <div className={'builds-best-runes-section__header-column'}>
                  {itemLabel}
                </div>
                <div className={'builds-best-runes-section__header-column'}>
                  {popularityLabel}
                </div>
              </div>
              <div className='builds-best-runes-section__header-section builds-best-runes-section__header-section--right'>
                <div className={'builds-best-runes-section__header-column'}>
                  {popularityLabel}
                </div>
                <div className={'builds-best-runes-section__header-column'}>
                  {itemLabel}
                </div>
              </div>
            </div>
            <div className='builds-best-runes-section__group'>
              {itemBreakdowns.map((itemBreakdown, index) => {
                return (
                  <div
                    key={index}
                    className={'builds-best-runes-section__item'}
                  >
                    {itemBreakdown && (
                      <BuildsItemBreakdown
                        key={index}
                        {...itemBreakdown}
                        side={index % 2 === 0 ? 'left' : 'right'}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </IconDefaultsContextProvider>
        ) : (
          <BuildsNoDataPlaceholder marginTop={1} />
        )}
      </div>
    </EnhancedMarkdownOptionsContextProvider>
  );
}
